module.exports = __webpack_public_path__ + "static/19-f9a53b51c4cee48d4b5be45d0ebc8a8e.jpg";